import React, {useEffect} from "react";
import ReportUtils from "../../../../../utils/report-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const ReportContent = ({data, details}) => {
  const navigate = navigateHook();

  useEffect(() => {
    ReportUtils.createExportableTable(null, null, `Equipamentos em uso`, "equipments-in-use");
  }, [data]);

  const formatAddress = (item) => {
    const parts = [];

    if (item.street) parts.push(item.street + ", ");
    if (item.number) parts.push(item.number + " - ");
    if (item.neighborhood) parts.push(item.neighborhood + ", ");
    if (item.city) parts.push(item.city);

    return parts.join("");
  };

  const generateSubTableRowData = (item,idx) =>
    <tr key={idx} className="text-center border-b border-[#e0e0e0]">
      <td><a className="cursor-pointer report-link" onClick={() => {
          navigate(`/janitorial/form/${item.id}`, true)
      }}>{item.id}</a></td>
      <td className="text-left">{formatAddress(item)}</td>
      <td>{item.quantity}</td>
    </tr>

  const generateSubTable = (data) =>
    <table className="table report-table max-w-[95%] mx-auto">
      <thead className="thead-background">
      <tr className="text-center !bg-[#f6f6f6]">
        <th className="w-[8%]!">Zeladoria</th>
        <th className="text-left">Endereço</th>
        <th>Quantidade</th>
      </tr>
      </thead>
      <tbody className="bg-white">
      {data.map((el, idx) => generateSubTableRowData(el, idx))}
      </tbody>
    </table>

  const generateRowData = (item, idx) =>
    <>
      <tr key={idx} className={`table-break-word ${details ? 'details-row' : ''}`}>
        <td>Equipamento: <span className="font-bold">{item.equipment}</span></td>
        <td className="text-center">Quantidade: <span className="font-bold">{item.total}</span></td>
      </tr>
      {details && item.description.length > 0 &&
        <tr className="search-details">
          <td colSpan={2}>
            {generateSubTable(item.description)}
          </td>
        </tr>
      }
    </>

  return(
    <>
      <table id="equipments-in-use" className="table report-table" sheet-name="Equipamentos em uso">
        <thead className="thead-background">
        <tr className={`bg-[#f6f6f6] ${details ? "hidden" : ""}`}>
          <th className="w-[90%] text-left">Equipamento</th>
          <th className="w-[10%] text-center">Quantidade</th>
        </tr>
        </thead>
        <tbody className="bg-white">
        {data.map((el, idx) => generateRowData(el, idx))}
        <tr className="hidden"> {/* apenas para aparecer o footer*/}
          <td className="w-[90%]"><span className="font-bold text-black!">Total</span></td>
          <td className="w-[10%] text-center"><span className="font-bold text-black!">{data.reduce((acc, el) => +el.total + acc, 0)}</span></td>
        </tr>
        </tbody>
        <tfoot>
          <tr className="bg-[#eeeeee]! border-b border-t border-[#e0e0e0]">
            <td className="w-[90%]"><span className="font-bold text-black!">Total</span></td>
            <td className="w-[10%] text-center"><span className="font-bold text-black!">{data.reduce((acc, el) => +el.total + acc, 0)}</span></td>
          </tr>
        </tfoot>
      </table>

      <div id="chart-tables"></div>
    </>
  )
}

export default ReportContent;